import { useQuery } from "react-query";
import { getScorecardType } from "../../../../actions/CarrierAgreementMgmt/ScoreCard";


export const useScorecardType = () => {
    const { data, isLoading, refetch } = useQuery(
        "GetScorecardType",
        getScorecardType,
        {
            refetchOnWindowFocus: false,
        }
    );

    return { data, isLoading, refetch };
};